import { PERMISSIONS } from '../usersPermissions/usersPermissionsCadernoLPMA';

export const isVisitor = (roles: string[]): boolean => {
    const isRole = roles.filter(role => role === PERMISSIONS.Visitante);

    return isRole.length ? true : false;
}